import { createContext, useContext } from 'react';

export const UpdateOptionContext = createContext();
export const useUpdateOption = () => useContext(UpdateOptionContext);
